// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3GT7p","rootCenter":"LoadMoreObserver_rootCenter__aqaaj","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__TQbId"};